import { useLocation } from 'react-router';

import { isToolsOrigin, readBackTo } from './backTo';

/**
 * The origin a chat started here should return to: the one carried in history state, or
 * the current page when it is a Tools page that nobody navigated to with an origin.
 */
export function useBackTo(): string | undefined {
  const location = useLocation();
  const fallback = isToolsOrigin(location.pathname) ? location.pathname : undefined;
  return readBackTo(location.state) ?? fallback;
}
